import type * as Api from 'Api'

export const recoveryPasswordErrorMessages: Dictionary<Dictionary<string>> = {
  email: {
    default: 'E-mail не найден',
    required: 'Введите электронную почту',
    email: 'Электронная почта введена неверно',
    undefined: 'Что-то пошло не так. Пожалуйста, повторите попытку',
  },
  password: {
    default:
      'Пароль ненадежный. Используйте прописные и строчные буквы, цифры и спецсимволы',
    required: 'Введите пароль',
    length: 'Пароль слишком короткий (Минимум 5 симв.)',
    format: 'Пароль не может содержать Кириллицу',
  },
  passwordConfirmation: {
    default: 'Пароли не совпадают',
    required: 'Введите пароль',
  },
}

export const recoveryPasswordErrorHandbook: Api.ErrorsHandbook<
  'default' | 'recovery'
> = {
  default: [],
  recovery: [
    {
      status: 1,
      code: 400,
      message: 'E-mail не найден',
    },
  ],
}
